module.exports = __webpack_public_path__ + "static/media/Clouds.9e9338dd.jpg";